import { BaseWindow } from "./BaseWindow";
import WebWindow from "./WebWindowWrapper";
import NativeWindow from "./externalWindowWrapper";
import { FSBLWindow } from "../localTypes";
import { StandardErrorCallback, StandardPromise } from "../../../../types";

BaseWindow.registerType("WebWindow", WebWindow);
BaseWindow.registerType("NativeWindow", NativeWindow);
BaseWindow.registerType("Citrix", NativeWindow);

export class FinsembleWindowInternal {
	static getInstance(params: any, cb?: StandardErrorCallback<any>): Promise<{ wrap: FSBLWindow }> {
		return BaseWindow.getInstance(params, cb) as Promise<{ wrap: FSBLWindow }>;
	}

	static async getInstanceStandardized(params: any): StandardPromise<FSBLWindow> {
		try {
			const result = await BaseWindow.getInstance(params);
			return { data: result.wrap as FSBLWindow };
		} catch (err: any) {
			return { err };
		}
	}
}
